import './WelcomeTour.scss';

import React, { FC, useContext } from 'react';
import { GlobalTourContext } from 'components/GlobalTourContext/GlobalTourContext';
import NavHeading, { NavHeadingProps } from 'components/NavHeading/NavHeading';
import { NavHeadings } from 'constants/Constants';
import { ArticleGenerationGuideKey } from 'data/intros/ArticleGen.Guide';
import { TeamEfficiencyGuideKey } from 'data/intros/TeamEfficiency.Guide';
import { TopicAuthorityGuideKey } from 'data/intros/TopicAuthority.Guide';
import { Button, Card, Col, Figure, Row } from 'react-bootstrap';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface WelcomeTourProps { }

const WelcomeTour: FC<WelcomeTourProps> = () => {
  const tour = useContext(GlobalTourContext)!;

  const heading: NavHeadingProps = {
    title: 'Welcome to BlabberJax!',
    ...NavHeadings.Welcome,
  };

  return (
    <div className="welcome-tour">
      <NavHeading {...heading} />
      <Row>
        <Col sm={5} md={3} className='shadow p-3 mb-5 bg-white rounded-20 welcome-bubble'>
          <Figure>
            <Figure.Image
              width={300}
              style={{ margin: '0 auto', textAlign: 'center' }}
              alt="Whizzandra Blogspark"
              src="/wizzandra-raw-image-welcome_v2.png"
              rounded
            />
            <Figure.Caption style={{ textAlign: 'center' }} className="text-light">
              Whizzandra Blogspark of Contentia
            </Figure.Caption>
          </Figure>
          <h4>
            <strong>Greetings marketier, I&#39;m your onboarding wizard!</strong>
          </h4>
          <p>
            Once the High Enchanter of Contentia, I now dwell in the realm of BlabberJax to guide bold marketiers like you.
            Together, we&#39;ll conjure seamless workflows, spellbinding content, and unstoppable SEO magic. <br />

            New to the realm? I&#39;ll guide your hand, young marketier. <i className='bi bi-magic' /> <br />
          </p>
          <Button
            variant='outline-light'
            href='https://www.blabberjax.com/about-whizzandra-blogspark/'
            target='_blank'
            rel='noreferrer'>
            Learn my backstory
          </Button>

        </Col>
        <Col className='pl-1'>
          <div className='row gx-2 help-guides'>
            <Card as={Col} lg={4} md={6} style={{ padding: 0, marginBottom: '.5em' }}>
              <Button variant="link" className='p-0' onClick={() => tour.navigateToNextStage('/account', TopicAuthorityGuideKey, 1)}>
                <Card.Img variant="top" src="/topic-authority-help-v2.png" />
              </Button>
              <Card.Body>
                <Card.Title>The Runes of Authority</Card.Title>
                <div className='card-text'>
                  <h6 style={{ fontStyle: 'italic' }}>&quot;One post is a whisper. A topic cluster is thunder.&quot;</h6>
                  Building unshakable SEO topic dominion across realms (and search engines) by crafting interlinked content castles.
                </div>
                <Button
                  onClick={() => tour.navigateToNextStage('/account', TopicAuthorityGuideKey, 1)}
                  className='button-bottom'
                  title="Top Authority"
                >
                  Topic Authority tour
                </Button>
              </Card.Body>
            </Card>

            <Card as={Col} lg={4} md={6} style={{ padding: 0, marginBottom: '.5em' }}>
              <Button variant="link" className='p-0' onClick={() => tour.navigateToNextStage('/documents/edit/new', TeamEfficiencyGuideKey, 1)}>
                <Card.Img variant="top" src="/workflow-help.png" />
              </Button>
              <Card.Body>
                <Card.Title>The Art of Flowmancy</Card.Title>
                <div className='card-text'>
                  <h6 style={{ fontStyle: 'italic' }}>&quot;Why manually when you can magickally?&quot;</h6>
                  Mastering team synergy, automation rituals, and deadline-bending content workflows that run like clockwork.
                </div>
                <Button
                  onClick={() => tour.navigateToNextStage('/documents/edit/new', TeamEfficiencyGuideKey, 1)}
                  className='button-bottom'
                  title="Flowmancy"
                >
                  Workflow tour
                </Button>
              </Card.Body>
            </Card>

            <Card as={Col} lg={4} md={6} style={{ padding: 0, marginBottom: '.5em' }}>
              <Button variant="link" className='p-0' onClick={() => tour.navigateToNextStage('/documents/edit/new', ArticleGenerationGuideKey, 1)}>
                <Card.Img variant="top" src="/first-blog-help-v2.png" />
              </Button>
              <Card.Body>
                <Card.Title>The Spark of the First Conjure</Card.Title>
                <div className='card-text'>
                  <h6 style={{ fontStyle: 'italic' }}>&quot;Just one flick of the wand — and boom! Instant brilliance.&quot;</h6>
                  Summoning killer content ideas and high-performing articles from a single spark of inspiration (or prompt).
                </div>
                <Button
                  onClick={() => tour.navigateToNextStage('/documents/edit/new', ArticleGenerationGuideKey, 1)}
                  className='button-bottom'
                  title="First Conjure"
                >
                  Content Creation tour
                </Button>
              </Card.Body>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default WelcomeTour;
